/**
 * @author Henal Khianra
 * @description https://marvelapp.com/prototype/4g4b5dg/screen/62578095
 */

import React, { Component } from 'react';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import split from 'ramda/src/split';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import Avatar from '@components/@core/Avatar';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import Icon from '@components/@core/Icon';
import EditDropdown from '@components/EditDropdown';
import AppActions from '~/actions/app';
import withNavigate from '~/hocs/withNavigate';

const PdfIcon = loadable(() => import('./QuotaDetailPdf'), { ssr: false });
const moment = extendMoment(originalMoment);

class QuotaDetail extends Component {
    state = {
        dateStart: moment().startOf('month'),
        dateEnd: moment().endOf('month'),
        quotaReports: this.props?.quotaReports,
        quotaId: this.props.params?.id,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { quotaReports } = nextProps;
        const quotaEmployee = find(propEq('id', parseInt(prevState.quotaId)), quotaReports?.quota_templates || []);
        const prevQuotaEmployee = find(propEq('id', parseInt(prevState.quotaId)), prevState.quotaReports?.quota_templates || []);

        if (quotaEmployee !== prevQuotaEmployee) {
            return { quotaReports: nextProps.quotaReports };
        } else return null;
    }

    handleMenu = (event, employee) => {
        const { dateStart, dateEnd } = this.state;

        if (event === 'save actuals') {
            this.props.toggleModal({
                type: 'Save Actuals',
                data: {
                    before: {
                        user: employee,
                        after: {
                            type: 'POSTQUOTAREPORT_REQUEST',
                            payload: {
                                date_start: dateStart,
                                date_end: dateEnd,
                                company_id: this.props.companyId,
                            },
                        },
                    },
                },
            });
        }
    };

    render() {
        const { dateStart, dateEnd, quotaReports, quotaId } = this.state;
        const quota_employee = find(propEq('id', parseInt(quotaId)), quotaReports.quota_templates);
        const date = moment.range(dateStart, dateEnd);

        return (
            <ErrorBoundary className="quota-reports-details">
                <Filter back="all quotas" />
                <div className="card overflow-hidden">
                    <div className="d-h-between">
                        <span className="dsl-b22 bold">{quota_employee?.name}</span>
                        <div className="d-flex">
                            <DatePicker calendar="month" append="caret" format="MMM YY" as="span" align="right" value={date} />
                            <div className="d-flex jc-end cursor-pointer ms-3">
                                <PdfIcon state={this.state} />
                            </div>
                        </div>
                    </div>
                    <div className="list-item mt-5 pb-2 d-flex desktop-screen">
                        <div className="d-flex-4 me-3 dsl-b16">
                            <span className="dsl-m12">Employee</span>
                        </div>
                        <div className="d-flex-4 ms-2 dsl-b16">
                            <span className="dsl-m12">Assignment</span>
                        </div>
                        <div className="d-flex-2 text-start dsl-b16">
                            <span className="dsl-m12">Since</span>
                        </div>
                        <div className="d-flex-1 ms-3 dsl-b16 text-end">
                            <p className="dsl-m12 d-flex-1 mb-0">Average</p>
                            <p className="dsl-m12 d-flex-1"> Actuals</p>
                        </div>
                        <div className="d-flex-3 dsl-b16 text-end">
                            <span className="dsl-m12">Recent Actual</span>
                        </div>
                        <div className="d-flex-2 text-end dsl-b16">
                            <span className="dsl-m12 ps-1 ps-md-0">Actual</span>
                        </div>
                        <div className="d-flex-1" />
                    </div>

                    {quota_employee?.users?.map((empQuota, index) => (
                        <div className="list-item pb-3 pt-3 d-flex ssm-column" key={index}>
                            <div className="d-h-between d-flex-4 me-3 w-100">
                                <div className="d-flex d-flex-4">
                                    <Avatar className="d-flex-1" name={empQuota.profile?.first_name + ' ' + empQuota.profile?.last_name} url={empQuota?.profile?.avatar} />
                                    <div className="d-flex-3 dsl-b14 text-400 ms-2 text-start ai-s-center">{empQuota.profile?.first_name + ' ' + empQuota.profile?.last_name}</div>
                                </div>
                                <EditDropdown className="mobile-screen" options={['Save Actuals']} onChange={(e) => this.handleMenu(e, empQuota)} />
                            </div>
                            <div className="d-flex ai-center d-flex-4 ms-2 ssm-l-0 dsl-b14 text-400 text-start w-100 py-2">
                                <label className="dsl-b14 mobile-screen w-40 mb-0">Assignment</label>
                                {empQuota?.quota_source ? split(':', empQuota?.quota_source)[0] : 'Not Assign'}
                            </div>
                            <div className="d-flex ai-center d-flex-2 text-end ssm-left dsl-b14 text-400 w-100 py-2">
                                <label className="dsl-b14 mobile-screen w-40 mb-0">Since</label>
                                {empQuota.assigned ? moment(empQuota.assigned).format('MMM DD, YYYY') : 'N/A'}
                            </div>
                            <div className="d-flex-1 dsl-b14 text-400 ms-3 ssm-l-0 text-end ssm-left w-100 py-2">
                                <label className="dsl-b14 mobile-screen w-40 mb-0">Actual Average</label>
                                {empQuota.actual_average}
                            </div>
                            <div className="d-flex-3 dsl-b14 text-400 text-end ssm-left w-100 py-2">
                                <label className="dsl-b14 mobile-screen w-40 mb-0">Recent Actual</label>
                                {empQuota.last_saved ? moment(empQuota.last_saved).format('MMM, YYYY') : 'N/A'}
                            </div>
                            <div className="d-flex-2 text-end ssm-left dsl-b14 text-400 w-100 py-2">
                                <label className="dsl-b14 mobile-screen w-40 mb-0">Actual</label>
                                {empQuota.recent_actual || 0}
                            </div>
                            <div className="d-flex-1 desktop-screen">
                                <EditDropdown options={['Save Actuals']} onChange={(e) => this.handleMenu(e, empQuota)} />
                            </div>
                        </div>
                    ))}
                </div>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    companyId: state.app.company_info.id,
    quotaReports: state.manage.quotaReports,
});

const mapDispatchToProps = (dispatch) => ({
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const QuotaDetailWithNavigate = withNavigate(QuotaDetail);
export default connect(mapStateToProps, mapDispatchToProps)(QuotaDetailWithNavigate);
